import React from 'react';
import { addReducer } from '../../redux/modules/root';
import { IAccountAction, IAccountState, IRootAccountState } from '../models';
import { accountRegistry } from '../redux';
import { getTelemetry } from '../../Telemetry/Telemetry';
import { ErrorBoundaryPage } from '../../Application/Page';

/**
 * This module contains the ability to route to the Organizations and for it be able to show in the left nav menu.
 * @description Registers routes to UI components, links, and business logic/state management in the form of reducers
 */

const AsyncNativeIdentitySupportedOrganizations = React.lazy(() =>
  import('./NativeIdentity/NativeIdentitySupportedOrganizations')
    .then((loaded) => ({
      default: loaded.NativeIdentitySupportedOrganizations,
    }))
    .catch((err) => {
      const telemetry = getTelemetry();
      telemetry.error(
        'resourceError/AsyncNativeIdentitySupportedOrganizations',
        `Failed to get bundle. Error details:  ${err}`,
      );
      throw err;
    }),
);

const AsyncAccountLeaveOrg = React.lazy(() =>
  import('./NativeIdentity/AccountLeaveOrg')
    .then((loaded) => ({
      default: loaded.AccountLeaveOrg,
    }))
    .catch((err) => {
      const telemetry = getTelemetry();
      telemetry.error('resourceError/AsyncAccountLeaveOrg', `Failed to get bundle. Error details:  ${err}`);
      throw err;
    }),
);

export const OrganizationsPage = () => {
  return (
    <ErrorBoundaryPage>
      <AsyncNativeIdentitySupportedOrganizations />
    </ErrorBoundaryPage>
  );
};

export const LeaveOrganizationsPage = () => {
  return (
    <ErrorBoundaryPage>
      <AsyncAccountLeaveOrg />
    </ErrorBoundaryPage>
  );
};

addReducer<IRootAccountState, IAccountState, IAccountAction>('account', accountRegistry);
